import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./components/Layout";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { createTheme, ThemeProvider } from "@mui/material/styles";
const GOOGLE_LOGIN_CLIENT_ID = process.env.GOOGLE_LOGIN_CLIENT_ID;

const theme = createTheme({
  typography: {
    fontFamily: `'Gilroy', sans-serif !important`,
  },
});

function App() {
  console.log(GOOGLE_LOGIN_CLIENT_ID);
  return (
    // Wrap your app
    <GoogleOAuthProvider
      clientId={
        "884061039356-k0hd40mo6aujgclfq5c6s67jeb1c267a.apps.googleusercontent.com"
      }
    >
      <ThemeProvider theme={theme}>
        <Layout />
      </ThemeProvider>
    </GoogleOAuthProvider>

    // <Router>

    // </Router>
  );
}

export default App;
